const mutations = {
    changeDarkMode(state) {
        state.darkMode = !state.darkMode
    },
    showContact(state) {
        state.navbar.show.profile = !state.navbar.show.profile
    },
    showMobileMenu(state) {
        state.navbar.show.mobileMenu = !state.navbar.show.mobileMenu
    },
    toaster(state, params) {
        state.toaster.show = true
        if ('message' in params) state.toaster.message = params.message
        if ('type' in params) state.toaster.type = params.type
        if ('time' in params) state.toaster.time = params.time
    },
    closeToaster (state) {
        state.toaster.show = false
    }
}

export default mutations